import { lazy } from "react";

const AssetsRoutes = [
    {
        path: "/assets/rebirth",
        component: lazy(() => import("../../views/assets/rebirth")),
    },
    {
        path: "/assets/access",
        component: lazy(() => import("../../views/assets/access")),
    },
    {
        path: "/assets/cosmetic",
        component: lazy(() => import("../../views/assets/cosmetic")),
    },
    {
        path: "/assets/crew",
        component: lazy(() => import("../../views/assets/crew")),
    },
    {
        path: "/assets/equipment",
        component: lazy(() => import("../../views/assets/equipment")),
    },
    {
        path: "/assets/ship",
        component: lazy(() => import("../../views/assets/ship")),
    },
    {
        path: "/assets/structure",
        component: lazy(() => import("../../views/assets/structure")),
    },
];

export default AssetsRoutes;
